module.exports = __webpack_public_path__ + "fonts/Inter-800-vietnamese75.9df1755.woff2";